import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'resourceOnePlanTaskPlanner';

const resourceOnePlanTaskPlannerService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  getResourceOnes: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/resourceOnes`,
      data,
    });
  },

  updateTask: (data, id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(id)}`,
      data,
    });
  },

  deleteTask: (id) => {
    return request({
      method: Methods.DELETE,
      resource: `${baseURL}/task/${encodeURIComponent(id)}`,
    });
  },

  searchTasks: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/search`,
      data,
    });
  },
};
export default resourceOnePlanTaskPlannerService;
